// pages/Commissions/utils/transform.ts
import { CommissionRegularPayload } from 'config/requests/comissions';
import omit from 'lodash/omit';

type CommissionsTransformInput = Pick<
  CommissionRegularPayload,
  'name' | 'merchant' | 'provider' | 'currency' | 'transactionTypes'
> & {
  rate: {
    min: string | null;
    max: string | null;
    fix: string | null;
    percent: string | null;
    zeroed: boolean;
  };
  calculationMethod?: string | null;
};

export const transform = <T extends CommissionsTransformInput>(
  data: T,
): CommissionRegularPayload => {
  const rest = omit(data, ['min', 'max', 'fix', 'percent', 'zeroed']) as Omit<
    T,
    'min' | 'max' | 'fix' | 'percent' | 'zeroed'
  >;

  return {
    //TODO: убрать omit после того как на беке удалят эти поля
    ...rest,
    rate: {
      min: data.rate.min ? data.rate.min + '' : null,
      max: data.rate.max ? data.rate.max + '' : null,
      fix: data.rate.fix ? data.rate.fix + '' : null,
      percent: data.rate.percent ? data.rate.percent + '' : null,
      zeroed: data.rate.zeroed,
    },
    calculationMethod: data.calculationMethod ?? null,
  };
};
